import SvgIcon from "@mui/material/SvgIcon";

export default function GrassIcon() {
  return (
    <SvgIcon>
      <path d="M7.69173 21C7.69173 21 8.2782 16.1471 5.43609 13.0588C6.83459 13.5882 7.91729 14.7353 8.2782 16.1471C8.2782 16.1471 8.2782 10.6324 3 8.33823C3 8.33823 8.2782 8.07353 10.3985 17.25C10.3985 17.25 11.6165 8.55882 5.84211 3C5.84211 3 11.2105 6.39706 11.9774 15.0882C11.9774 15.0882 12.0677 8.64706 14.6391 5.47059C14.6391 5.47059 12.6541 12.4412 13.6015 17.1176C13.6015 17.1176 13.8271 6.22059 21 3.57353C21 3.57353 15.4962 5.25 15.406 17.7353C15.406 17.7353 15.6767 13.4118 19.6466 12C16.9398 13.8971 16.7594 17.1176 16.5789 21H7.69173Z" />
    </SvgIcon>
  );
}
